import rgba from "polished/lib/color/rgba";
import colors from "ui-components/colors";
const sizeCommon = {
  borderRadius: 6
};
const sizes = {
  big: { ...sizeCommon,
    iconSizes: [18, 24],
    fontSize: 17,
    fontWeight: 600,
    height: 48,
    textTransform: "uppercase",
    padding: 15,
    _padding: [30, 38]
  },
  medium: { ...sizeCommon,
    iconSizes: [16, 20],
    fontSize: 14,
    fontWeight: 600,
    height: 40,
    textTransform: "uppercase",
    padding: 12,
    _padding: [34, 42]
  },
  small: { ...sizeCommon,
    iconSizes: [16, 18],
    fontSize: 14,
    fontWeight: 400,
    height: 32,
    textTransform: "uppercase",
    padding: 6,
    _padding: [28, 36]
  },
  xs: { ...sizeCommon,
    borderRadius: 4,
    iconSizes: [12, 14],
    fontSize: 12,
    fontWeight: 400,
    height: 24,
    textTransform: "none",
    padding: 6,
    _padding: [16, 24]
  }
};
const common = {
  default: {
    passive: {
      background: "transparent",
      fontColor: colors.coal,
      borderColor: colors.coal,
      borderWidth: 2
    },
    hover: {
      fontColor: colors.white,
      background: colors.coal,
      borderColor: colors.coal
    },
    active: {
      borderWidth: 2,
      fontColor: colors.white,
      background: rgba(colors.coal, 0.7),
      borderColor: colors.coal
    },
    disabled: {
      borderWidth: 2,
      background: "transparent",
      borderColor: rgba(colors.coal, 0.35),
      fontColor: rgba(colors.coal, 0.35)
    },
    loading: {
      borderWidth: 2,
      background: "transparent",
      borderColor: rgba(colors.coal, 0.5),
      fontColor: colors.coal,
      color: rgba(colors.coal, 0.3)
    }
  }
};
const flat = {
  default: common.default,
  light: { ...common.default,
    passive: { ...common.default.passive,
      fontColor: colors.coal,
      borderColor: rgba(colors.coal, 0.35)
    },
    hover: { ...common.default.hover,
      borderWidth: 0,
      fontColor: colors.coal,
      background: rgba(colors.coal, 0.35),
      borderColor: colors.lighterCoal
    },
    active: {
      borderWidth: 2,
      background: rgba(colors.coal, 0.245),
      borderColor: rgba(colors.coal, 0.35)
    },
    disabled: { ...common.default.disabled,
      borderColor: rgba(colors.coal, 0.1225)
    },
    loading: {
      borderWidth: 2,
      background: "transparent",
      borderColor: rgba(colors.coal, 0.35),
      fontColor: colors.coal,
      color: rgba(colors.coal, 0.3)
    }
  },
  danger: { ...common.default,
    passive: { ...common.default.passive,
      background: "transparent",
      fontColor: "#FB2929",
      borderColor: "#FB2929"
    },
    hover: { ...common.default.hover,
      fontColor: colors.white,
      borderWidth: 0,
      background: "#FB2929"
    },
    active: {
      borderWidth: 2,
      fontColor: colors.white,
      background: rgba("#FB2929", 0.7),
      borderColor: "#FB2929"
    },
    disabled: {
      borderWidth: 2,
      background: "transparent",
      borderColor: rgba("#FB2929", 0.35),
      fontColor: rgba("#FB2929", 0.35)
    },
    loading: {
      borderWidth: 2,
      background: "transparent",
      borderColor: rgba("#FB2929", 0.5),
      fontColor: "#FB2929",
      color: rgba("#FB2929", 0.3)
    }
  },
  primary: { ...common.default,
    passive: { ...common.default.passive,
      fontColor: colors.white,
      background: colors.primary,
      borderColor: "transparent"
    },
    hover: { ...common.default.hover,
      background: "#FF6828",
      borderColor: "#FF6828"
    },
    active: {
      background: "#EA4600",
      borderColor: "#EA4600"
    },
    disabled: {
      borderWidth: 0,
      background: rgba(colors.primary, 0.35),
      fontColor: colors.white
    },
    loading: {
      background: rgba(colors.primary, 0.5),
      borderColor: "transparent",
      fontColor: colors.white,
      color: rgba(colors.primary, 0.5)
    }
  },
  primaryLight: { ...common.default,
    passive: { ...common.default.passive,
      fontColor: colors.primary,
      borderColor: colors.primary
    },
    hover: { ...common.default.hover,
      background: colors.primary,
      borderColor: colors.primary
    },
    active: {
      borderWidth: 2,
      fontColor: colors.white,
      background: rgba(colors.primary, 0.7),
      borderColor: colors.primary
    },
    disabled: {
      borderWidth: 2,
      background: "transparent",
      borderColor: rgba(colors.primary, 0.35),
      fontColor: rgba(colors.primary, 0.35)
    },
    loading: {
      borderWidth: 2,
      borderColor: rgba(colors.primary, 0.5),
      fontColor: colors.primary,
      color: rgba(colors.primary, 0.3)
    }
  },
  success: { ...common.default,
    passive: { ...common.default.passive,
      fontColor: colors.white,
      borderWidth: 0,
      background: "#27AE60"
    },
    hover: { ...common.default.hover,
      borderWidth: 0,
      background: "#39C173"
    },
    active: {
      borderWidth: 0,
      background: "#21A559"
    },
    disabled: {
      borderWidth: 0,
      background: rgba("#27AE60", 0.35)
    },
    loading: {
      borderWidth: 0,
      background: rgba("#27AE60", 0.5),
      color: rgba("#27AE60", 0.5)
    }
  },
  black: { ...common.default,
    passive: { ...common.default.passive,
      borderWidth: 0,
      fontColor: colors.white,
      background: colors.coal
    },
    hover: { ...common.default.hover,
      borderWidth: 0,
      background: "#4F4A58"
    },
    active: {
      borderWidth: 0,
      background: "#2D2B31"
    },
    disabled: {
      borderWidth: 0,
      background: rgba(colors.coal, 0.35)
    },
    loading: {
      borderWidth: 0,
      background: rgba(colors.coal, 0.175),
      color: rgba(colors.coal, 0.3)
    }
  }
};
const themes = {
  flat
};
export { themes, sizes };